import {forwardRef, Inject, Injectable} from '@angular/core';
import {ServerConfiguration,} from '../model/common.model';
import {SessionService} from './session.service';
import {TranslateService} from '@ngx-translate/core';
import {JSonSerializer} from '../model/JSonSerializer';
import {Router} from "@angular/router";
import {Observable} from "rxjs";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable()
export class TraceService {

  private _serverConfiguration: ServerConfiguration;

  private _canTrace = false;

  constructor(private http: HttpClient,
                @Inject(forwardRef(() => Router)) private router: Router,
                @Inject(forwardRef(() => TranslateService)) private translate: TranslateService,
                @Inject(forwardRef(() => SessionService)) private session: SessionService) {

    this.loadConfiguration().then((serverConfig)=>{
      this._serverConfiguration = serverConfig;
      if (this._serverConfiguration!=null){
        if (this._serverConfiguration.traceActive!=null){
          this._canTrace = this._serverConfiguration.traceActive;
        }
      }
      if (!this.canTrace){
        console.log('TraceService is not active.');
      }else{
        console.log('TraceService is active, ' + this._serverConfiguration.traceServer);
      }

    });

  }

  private get canTrace():boolean{
    return this._canTrace;
  }


  loadConfiguration(): Promise<ServerConfiguration> {
            return this.http.get('configuration.json',{headers : this._getHeaders() }).toPromise().then(

                // response => console.log('response ' + response.json().server + ' response.text ' + response.text() )
                response => {
                              //console.log('loadConfiguration ' + JSON.stringify(response.json()));
                              return response as ServerConfiguration;
                            },
                rejected => { return {server: 'No Server found.', download: 'No Download Server Found',downloadContent:'No downloadContent Server Found',storeSession:false} ; }
            );
    }


  private _getHeaders():HttpHeaders{
    // 180 days in seconds
    const headers = new HttpHeaders({'Strict-Transport-Security': 'max-age: 15552000; includeSubDomains'});
    console.log('Using _getHeaders, ' + headers.get('Strict-Transport-Security'));
    return headers;
  }


    private _handleRejected(rejected:any){
      console.log('rejected: ' + JSON.stringify(rejected));

       return {success:false,description: rejected + ''};
    }


    public serverUrl(url: string ): string {
        const urlComplete = this._serverConfiguration.traceServer.concat(url);
        // console.log('CompleteUrl: ' + urlComplete);
        return urlComplete;
    }

  sendTrace(description: string, extra?: any, username?:any){
    this.sendTraceInternal(description,extra,username).subscribe(()=>{},null, ()=>{
    //  console.log('Trace has been processed.');
    });

  }


  private sendTraceInternal(description: string, extra?: any, username?:any): Observable<string> {

    return new Observable<string>((observer)=>{
      if (this.canTrace){
        const serializer = new JSonSerializer();
        let headers = new HttpHeaders({ 'Content-Type': 'application/json'});
        const trace = new TraceFromEmprez();
        trace.registererCode = this._serverConfiguration.traceRegistererCode;
        if (username){
          trace.user = username;
        }else{
          console.log('Checking UserInfo ' + description);
          if (this.session.userInfo){
            trace.user = this.session.userInfo.user.username;
            trace.fullName = this.session.userInfo.fullName;
            headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Accept-Language': this.session.userInfo.locale,
              'X-XSRF-TOKEN':this.session.xsrfToken});

          }
        }
        trace.description = description;
        if (extra){
          trace.extra = serializer.serialize(extra);
        }
        // , withCredentials:true MUST be removed otherwise CORS  is complaining...
        this.http.post<string>( this.serverUrl('saveTraceFromEmprez'), serializer.prepareForJson(trace),  { headers: headers })
          .subscribe({
              next: (response) => {
                // console.log('response trace sent : ' + response.json() );
                observer.next(response);
                observer.complete();
                observer.unsubscribe()
              },
              error: (rejected) => {
                observer.error(rejected);
                observer.complete();
                observer.unsubscribe()
                // return this._handleRejected(rejected);
              }
            }
          );
      }else{
        observer.complete();
        observer.unsubscribe()
      }
    });

  }





}

class TraceFromEmprez {
  registererCode: string;
  user: string;
  fullName: string;
  description: string;
  extra: string;
}


